// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b51296ad2186e937e6f2","655":"8d489f0c2a86fba30e8c"}[chunkId] + ".js";
};